import React, { Component } from "react";
import {
  Layout,
  Menu,
  Divider,
  Statistic,
  Row,
  Col,
  Progress,
  Button,
  message,
  notification,
} from "antd";
import "./style.css";
import Spinner from "../../../../../components/spinner";
import {
  WarningTwoTone,
  FieldTimeOutlined,
  SolutionOutlined,
  AudioOutlined,
  VideoCameraOutlined,
  OrderedListOutlined,
  FilePdfOutlined,
} from "@ant-design/icons";
import { Link } from "react-router-dom";
import PlayButton from "../../../../../Images/timeLine/cardButtons/playButton.png";
import PdfButton from "../../../../../Images/timeLine/cardButtons/pdfButton.png";
import AudioButton from "../../../../../Images/timeLine/cardButtons/audio.png";
import VideoModal from "../../../../../components/userSide/modals/vidModal";
import QuizModal from "../../../../../components/userSide/modals/quizModal";
import { Jumbotron, Card, CardImg, CardTitle } from "reactstrap";
import Thumbnail1 from "../../../../../Images/timeLine/cardThumbnail/vidthumbnail.jpg";
import Thumbnail2 from "../../../../../Images/timeLine/cardThumbnail/vidthumbnail1.jpg";
import Thumbnail3 from "../../../../../Images/timeLine/cardThumbnail/vidthumbnail2.jpg";
import Thumbnail4 from "../../../../../Images/timeLine/cardThumbnail/vidthumbnail3.jpg";
import Thumbnail5 from "../../../../../Images/timeLine/cardThumbnail/vidthumbnail4.jpg";
import Thumbnail6 from "../../../../../Images/timeLine/cardThumbnail/vidthumbnail5.jpg";

const { Sider, Content } = Layout;

class CoursesPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      key: 0,
      collapsed: false,
      course: "",
      currentTopic: "",
      currentVideo: "",
      loader: true,
      vidModal: false,
      quizModal: false,
      quizData: [],
      userId: "",
      courseCompleted: [],
      currentImageIndex: 0,
      topicCardThumbnails: [
        Thumbnail1,
        Thumbnail2,
        Thumbnail3,
        Thumbnail4,
        Thumbnail5,
        Thumbnail6,
      ],
    };
  }

  componentDidMount = () => {
    const { courseID, courses, user } = this.props;
    // console.log(user._id);
    // eslint-disable-next-line
    courses.map((item) => {
      if (item._id === courseID) {
        this.setState(
          {
            course: item,
            loader: false,
            userId: user._id,
            courseCompleted: !user.courseCompleted ? [] : user.courseCompleted,
          },
          () => {
            // console.log(this.state);
          }
        );
      }
    });
  };

  notActiveNotification = () => {
    let placement = "bottomRight";
    const key = `open${Date.now()}`;
    notification.open({
      duration: 5,
      message: "Attention Champion!",
      description: (
        <div id="loading">
          <h3>This feature is under development.</h3>
          <p>Please visit again later, Thanks.</p>
        </div>
      ),
      placement,
      icon: <WarningTwoTone twoToneColor="#BF2F2F" />,
      key,
    });
  };

  playVideo = (topic, video) => {
    this.setState({
      currentTopic: topic,
      currentVideo: video,
    });
  };

  onCollapse = (collapsed) => {
    this.setState({ collapsed });
  };

  changeImage = () => {
    this.courseStatusMessage();
    const randomNumber = Math.floor(
      Math.random() * this.state.topicCardThumbnails.length
    );
    this.setState({
      currentImageIndex: randomNumber,
    });
  };

  onSubmitUpdate = () => {
    console.log(this.state);
    fetch(
      "https://sbhs-web-server.herokuapp.com/lte/user/edit",
      // "http://localhost:4000/lte/user/edit",
      {
        method: "put",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          id: this.state.userId,
          courseCompleted: this.state.courseCompleted,
        }),
      }
    )
      .then((response) => response.json())
      .then((response) => {
        console.log("submit response ", response);
      })
      .then(() => {
        this.successAlert("Course Completed Successfully");
      });
  };

  successAlert = (text) => {
    message.success(text);
  };

  courseCompleted = () => {
    const { course, courseCompleted } = this.state;
    // if (courseCompleted.includes(course._id)) {
    //   // this.successAlert("Course Already Completed by you");
    // } else {
    //   const temp = courseCompleted;
    //   temp.push(course._id);
    //   this.setState({ courseCompleted: temp });
    //   // console.log(courseCompleted);
    //   this.onSubmitUpdate();
    // }
    const temp = courseCompleted;
    temp.push(course._id);
    this.setState({ courseCompleted: temp });
    // console.log(courseCompleted);
    this.onSubmitUpdate();
  };

  courseStatusMessage = () => {
    // console.log("course length", this.state.course.courseTopics.length);
    // console.log("key", this.state.key);

    if (
      this.state.courseCompleted.includes(this.state.course._id) &&
      this.state.key === 1
    ) {
      return message.success("Course has been already completed by you.", 5);
    }
    if (
      !this.state.courseCompleted.includes(this.state.course._id) &&
      this.state.key === 1
    ) {
      message.warning(
        "Kindly complete & submit current topic in order to unlock next course.",
        5
      );
    }
  };

  render() {
    const {
      courseTopics,
      courseTitle,
      courseDesc,
      createdDate,
      courseMinutes,
      // createdBy,
      _id,
    } = this.state.course;

    return (
      <div className="mainDiv11">
        {this.state.loader ? (
          <div className="tc">
            <Spinner />
          </div>
        ) : (
          <Layout className="layOut11">
            <Sider
              collapsible
              collapsed={this.state.collapsed}
              onCollapse={this.onCollapse}
            >
              <div className="logo" />
              <Menu theme="dark" mode="inline" defaultSelectedKeys={["1"]}>
                <Menu.Item id="coursesSiderHeadeing">
                  <Link to="/courses">
                    <b>All Courses</b>
                  </Link>
                </Menu.Item>
                <Menu.Item
                  key="1"
                  onClick={() => {
                    this.setState({
                      key: 0,
                    });
                  }}
                >
                  <b>Intorduction</b>
                </Menu.Item>
                {courseTopics.map((item, i) => {
                  return (
                    <Menu.Item
                      key={i + 2}
                      onClick={() => {
                        this.changeImage();
                        this.setState({
                          key: i + 1,
                        });
                      }}
                    >
                      {i + 1 + ". " + item.topicTitle}
                    </Menu.Item>
                  );
                })}
              </Menu>
            </Sider>

            <Layout className="site-layout TableFrame">
              {this.state.key === 0 ? (
                <Content
                  className="site-layout-background"
                  style={{
                    padding: 24,
                    minHeight: 280,
                    // textAlign: "center",
                    // fontSize: "40px",
                  }}
                >
                  <Divider>{courseTitle}</Divider>
                  <div dangerouslySetInnerHTML={{ __html: courseDesc }} />
                  <br />
                  <Row gutter={24}>
                    <Col span={18}>
                      <ul>
                        <li>Course ID - {_id}</li>
                        <li>Created by - {"Salman Aslam"}</li>
                        <li>Dated - {createdDate}</li>
                      </ul>
                    </Col>
                    <Col span={6}>
                      {courseTopics.length !== 0 ? (
                        <Button
                          onClick={() => {
                            this.setState({
                              key: 1,
                            });
                          }}
                          className="beginButton animate__animated animate__lightSpeedInLeft"
                        >
                          Begin Course
                        </Button>
                      ) : (
                        <Link to={"/courses"}>
                          <Button
                            onClick={() => {
                              this.courseCompleted("No Topic");
                            }}
                            className="beginButton animate__animated animate__lightSpeedInLeft"
                          >
                            No Topics Attached, <br /> Skip Course
                          </Button>
                        </Link>
                      )}
                    </Col>
                  </Row>
                  <Divider>Course Content</Divider>
                  <Row gutter={24}>
                    <Col span={4}>
                      <Statistic
                        title="Total Topics"
                        value={courseTopics.length}
                        prefix={<OrderedListOutlined />}
                      />
                    </Col>
                    <Col span={4}>
                      <Statistic
                        title="Total Videos"
                        prefix={<VideoCameraOutlined />}
                        value={0}
                      />
                    </Col>
                    <Col span={4}>
                      <Statistic
                        title="PDF"
                        prefix={<FilePdfOutlined />}
                        value={0}
                      />
                    </Col>
                    <Col span={4}>
                      <Statistic
                        title="Audio"
                        prefix={<AudioOutlined />}
                        value={0}
                      />
                    </Col>
                    <Col span={4}>
                      <Statistic
                        title="Quizes"
                        prefix={<SolutionOutlined />}
                        value={0}
                      />
                    </Col>
                    <Col span={4}>
                      <Statistic
                        title="Time Required (in-mins)"
                        prefix={<FieldTimeOutlined />}
                        value={courseMinutes}
                      />
                    </Col>
                  </Row>
                  <Divider>Course Progress</Divider>
                  <Row gutter={24}>
                    <Col span={4}>
                      <Progress type="circle" percent={0} width={80} />
                    </Col>
                    <Col span={4}>
                      <Progress type="circle" percent={0} width={80} />
                    </Col>
                    <Col span={4}>
                      <Progress type="circle" percent={0} width={80} />
                    </Col>
                    <Col span={4}>
                      <Progress type="circle" percent={0} width={80} />
                    </Col>
                    <Col span={4}>
                      <Progress type="circle" percent={0} width={80} />
                    </Col>
                    <Col span={4}>
                      <Progress type="circle" percent={0} width={80} />
                    </Col>
                  </Row>
                  {/* <Row gutter={24}>
                    <Col span={24}>
                      <Progress
                        strokeColor={{
                          from: "#000000",
                          to: "#87d068",
                        }}
                        percent={0}
                        status="active"
                      />
                    </Col>
                  </Row> */}
                </Content>
              ) : this.state.key > 0 ? (
                <div>
                  {courseTopics.map((item, i) => {
                    return this.state.key === i + 1 ? (
                      <Content className="site-layout-background">
                        <Jumbotron className="timelineJumbotron">
                          <Row gutter="24">
                            <Col span="16">
                              <h5 className="display-4">{item.topicTitle}</h5>
                              <div
                                className="lead"
                                dangerouslySetInnerHTML={{
                                  __html: item.topicDetail,
                                }}
                              />
                            </Col>
                            <Col span="8">
                              {" "}
                              <Card className="timelineCard">
                                <CardImg
                                  className="timelineCardImage"
                                  src={
                                    item.topicThumbnailImageUrl === ""
                                      ? this.state.topicCardThumbnails[
                                          this.state.currentImageIndex
                                        ]
                                      : item.topicThumbnailImageUr
                                  }
                                  alt="thumbnail"
                                />
                                <CardTitle className="timelineCardTitle">
                                  <br />
                                  <Row gutter="24">
                                    {item.video !== "" ? (
                                      <Col span="8">
                                        {" "}
                                        <img
                                          src={PlayButton}
                                          style={{ cursor: "pointer" }}
                                          onClick={() =>
                                            this.setState({
                                              videoLink: item.video,
                                              vidModal: true,
                                            })
                                          }
                                          alt="Topic Video"
                                          width="30px"
                                          title="video"
                                        />
                                      </Col>
                                    ) : null}

                                    {item.audio !== "" ? (
                                      <Col span="8">
                                        <a // eslint-disable-next-line
                                          target="_blank"
                                          href={item.audio}
                                        >
                                          <img
                                            src={AudioButton}
                                            alt="Topic Audio"
                                            width="30px"
                                            title="audio"
                                          />
                                        </a>
                                      </Col>
                                    ) : null}

                                    {item.pdf !== "" ? (
                                      <Col span="8">
                                        <a // eslint-disable-next-line
                                          target="_blank"
                                          href={item.pdf}
                                        >
                                          <img
                                            title="pdf"
                                            src={PdfButton}
                                            alt="Topic Pdf"
                                            width="30px"
                                          />
                                        </a>
                                      </Col>
                                    ) : null}
                                  </Row>
                                </CardTitle>
                              </Card>
                              {item.audio === "" &&
                              item.pdf === "" &&
                              item.quiz === "" &&
                              item.video === "" ? (
                                <h5>No Attachments</h5>
                              ) : (
                                <div>
                                  {" "}
                                  <h5>Current Topic Attachments:</h5>
                                  <ul>
                                    {item.video !== "" ? (
                                      <li>Video Tutorial</li>
                                    ) : null}
                                    {item.audio !== "" ? (
                                      <li>Topic Audio</li>
                                    ) : null}
                                    {item.pdf !== "" ? (
                                      <li>Pdf Document</li>
                                    ) : null}
                                    {item.quiz !== "" ? (
                                      <li>Topic Quiz</li>
                                    ) : null}
                                  </ul>
                                </div>
                              )}
                            </Col>
                          </Row>
                          <br />
                          <Row gutter={24}>
                            <Col span={18}>
                              {item.quiz.length > 0 ? (
                                <Button
                                  onClick={() => {
                                    this.setState({
                                      quizData: item.quiz,
                                      quizModal: true,
                                    });
                                  }}
                                  className="beginButton animate__animated animate__lightSpeedInRight"
                                >
                                  Begin Quiz
                                </Button>
                              ) : null}
                            </Col>
                            {courseTopics.length === this.state.key ? (
                              <Col span={6}>
                                <Link to={"/courses"}>
                                  {" "}
                                  <Button
                                    onClick={() => {
                                      this.courseCompleted(item);
                                    }}
                                    className="beginButton animate__animated animate__lightSpeedInLeft"
                                  >
                                    "Complete Course"
                                    {/* {this.state.courseCompleted.includes(
                                      this.state.course._id
                                    )
                                      ? "Back to Courses"
                                      : "Complete Course"} */}
                                  </Button>
                                </Link>
                              </Col>
                            ) : (
                              <Col span={6}>
                                <Button
                                  onClick={() => {
                                    this.changeImage();
                                    this.setState({
                                      key: this.state.key + 1,
                                    });
                                  }}
                                  className="beginButton animate__animated animate__lightSpeedInLeft"
                                >
                                  Next Topic
                                </Button>
                              </Col>
                            )}
                          </Row>
                        </Jumbotron>
                      </Content>
                    ) : null;
                  })}
                </div>
              ) : null}
            </Layout>
          </Layout>
        )}

        <VideoModal
          that={this}
          opener={this.state.vidModal}
          videoLink={this.state.videoLink}
        />
        <QuizModal
          that={this}
          opener={this.state.quizModal}
          quizData={this.state.quizData}
        />
      </div>
    );
  }
}
export default CoursesPage;
